<!-- eslint-disable @angular-eslint/template/label-has-associated-control -->
<ng-container>
  <label
    class="wrapper"
    [ngClass]="{ active: isActive() }"
    role="button"
    [tabindex]="name() + '-checkbox'">
    <orbit-checkbox [type]="type()" [name]="name()" [value]="value()" [controller]="controller()" />
    <div class="extended-text">
      <div class="description">{{ item() }}</div>
      <div class="details">{{ description() }}</div>
      <div class="details">{{ subtitle() }}</div>
    </div>

    <!-- ★ star toggle (optional) -->
    <button
      [title]="isFavorite() ? titleForUnFavorite() : titleForFavorite()"
      *ngIf="showFavorite()"
      type="button"
      class="favorite-btn"
      (click)="onFavoriteClick($event)">
      @if (isFavorite()) {
        <orbit-fa-icon [ngClass]="'default-star filled'" [iconName]="star" />
      } @else {
        <orbit-fa-icon [ngClass]="'default-star'" [iconName]="star" />
      }
    </button>
  </label>
</ng-container>
